module.exports = __webpack_public_path__ + "img/product_rjkf1.94b7421c.png";